export enum AuthLogicTypes {
  authStart = 'AUTHLOGIC/AUTH_REQUEST_SEND',
  authFail = 'AUTHLOGIC/AUTH_REQUEST_FAIL',
  authDone = 'AUTHLOGIC/AUTH_REQUEST_SUCCESS',
  login = 'AUTHLOGIC/LOGIN',
  logoutStart = 'AUTHLOGIC/LOGOUT_SEND',
  logoutDone = 'AUTHLOGIC/LOGOUT_DONE',
  updateUser = 'AUTHLOGIC/UPDATE_USER',
  initUser = 'INIT_USER',
  fulfillImpersonation = 'AUTHLOGIC/FULFILL_IMPERSONATION',
}

export enum FetchUserBillingInfoTypes {
  start = 'AUTHLOGIC/FETCH_USER_BILLING_INFO_START',
  done = 'AUTHLOGIC/FETCH_USER_BILLING_INFO_SUCCESS',
  fail = 'AUTHLOGIC/FETCH_USER_BILLING_INFO_FAIL',
}

export enum RecoverPasswordTypes {
  start = 'RECOVER_PASSWORD_SEND',
  done = 'RECOVER_PASSWORD_SUCCESS',
  fail = 'RECOVER_PASSWORD_FAIL',
}

export enum ImpersonateUserTypes {
  start = 'AUTHLOGIC/IMPERSONATION_START',
  done = 'AUTHLOGIC/IMPERSONATION_DONE',
  fail = 'AUTHLOGIC/IMPERSONATION_FAIL',
}

export const newPayReqCreationDismissed = 'new_pay_req_creation_dismissed';
export const newPayReqOverviewDismissed = 'new_pay_req_overview_dismissed';
